export default {
	about: {
		title: false,
	},
	main: {
		tagline: true,
	},
	services: {
		title: true,
		disabled: true,
	},
	accolades: {
		title: true,
		disabled: true,
	},
	widgets: {
		title: true,
	},
	testimonials: {
		title: true,
		slideSpeed: false,
		height: false,
		style: false,
	},
	contact: {
		title: true,
	},
};
